import { Modal } from '@lsq-frontend/common-ui';
import { BuyerAccountInvoiceUploadSuccessModalComponent } from './buyer-account-invoice-upload-success-modal.component';

export class InvoiceUploadModal extends Modal {
    public id = 'base-invoice-upload-modal';
    public showFooter = false;
    public showCloseButton = true;
    public showOkButton = false;
    public width = '430';
}

export class InvoiceUploadSuccessModal extends InvoiceUploadModal {
    public component = BuyerAccountInvoiceUploadSuccessModalComponent;
}
